"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _avatar = _interopRequireDefault(require("../Avatar/avatar"));

var _image = _interopRequireDefault(require("../Image/image"));

var _illustration = _interopRequireDefault(require("../Illustration/illustration"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Media(_ref) {
  var children = _ref.children,
      reversed = _ref.reversed,
      props = _objectWithoutProperties(_ref, ["children", "reversed"]);

  var _React$Children$toArr = _react.default.Children.toArray(children),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      image = _React$Children$toArr2[0],
      content = _React$Children$toArr2.slice(1);

  var styles = {
    'co-media': true,
    'co-media--reverse': reversed
  };
  return _react.default.createElement(_styler.default, {
    classNames: styles,
    modifiers: props
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), _react.default.createElement(MediaImages, null, image), _react.default.createElement(MediaContent, null, content));
  });
}

function MediaImages(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: "co-media__images"
  }, children);
}

function MediaContent(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: "co-media__content"
  }, children);
}

var exclusiveVerticalAlignments = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('alignTop', 'alignVerticalCenter', 'alignBottom');
var mediaImagesTypes = (0, _airbnbPropTypes.childrenOf)((0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.elementType)(_icon.default), (0, _airbnbPropTypes.elementType)(_avatar.default), (0, _airbnbPropTypes.elementType)(_image.default), (0, _airbnbPropTypes.elementType)(_illustration.default)]));
Media.propTypes = {
  children: _propTypes.node.isRequired,
  reversed: _propTypes.bool,
  alignTop: exclusiveVerticalAlignments,
  alignVerticalCenter: exclusiveVerticalAlignments,
  alignBottom: exclusiveVerticalAlignments
};
MediaImages.propTypes = {
  children: mediaImagesTypes.isRequired
};
MediaContent.propTypes = {
  children: _propTypes.node.isRequired
};
var _default = Media;
exports.default = _default;
Media.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Media",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "reversed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "alignTop": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalAlignments"
      },
      "required": false,
      "description": ""
    },
    "alignVerticalCenter": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalAlignments"
      },
      "required": false,
      "description": ""
    },
    "alignBottom": {
      "type": {
        "name": "custom",
        "raw": "exclusiveVerticalAlignments"
      },
      "required": false,
      "description": ""
    }
  }
};